<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Dosya Türü</label>
            <v-select-list :options="types" v-model="type" label="Name" :disabled="types.length == 0" placeholder="Dosya Türü"></v-select-list>
        </div>
        <div class="col-12">
            <label class="form-label">Dosya</label>
            <file-uploader :accept="['pdf']" :value="value" valueParameter="File" ></file-uploader>
        </div>
    </div>
</template>

<script>
import FileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import DocumentOperationsApi from '@/api/document-operations'
export default {
    components:{
        FileUploader
    },
    props:{
        value:Object
    },
    data(){
        return{
            types:[]
        }
    },
    mounted(){
        this.getTypes()
    },
    methods:{
        getTypes(){
            DocumentOperationsApi.VehicleInventory.List().then(res=>{
                this.types = res.data.Data
            })
        }
    },
    computed:{
        type:{
            get:function(){
                return this.types.find(b=>b.SystemCode==this.value.SystemCode)
            },
            set:function(value){
                this.value.SystemCode = value?.SystemCode || null
            }
        }
    }
}
</script>